import { Col, Row, Space, Typography, Dropdown } from "antd";
import PointsRulesView from "../components/PointsRulesView";
import { useState } from "react";
import PointsRuleFormDialog from "../components/PointsRuleFormDialog";
import { PointsRule } from "../repository/data.default";
import { Guid } from "guid-typescript";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";

// PD-01 §8 — admin-managed Points Rules (which engagement events award how
// many points). Backed by LoyaltyAccrualRulesController.
function PointsRulesPage() {
  const [inputMode, setInputMode] = useState<"add" | "update" | "delete">("add");
  const [inputOpen, setInputOpen] = useState(false);
  const [inputValues, setInputValues] = useState<PointsRule>({} as any);
  const [triggerView, setTriggerView] = useState(Guid.create().toString());
  const permissions = useSelector(authorizeSelectors.permissions);

  function onInputOpen(mode: "add" | "update" | "delete", values?: PointsRule): void {
    setInputMode(mode);
    setInputOpen(true);
    setInputValues(values || ({} as any));
  }

  function onInputFinish(): void {
    setInputOpen(false);
    setInputValues({} as any);
    setTriggerView(Guid.create().toString());
  }

  return (
    <Col className="relative flex flex-auto flex-col overflow-hidden overflow-y-auto">
      <Row className="sticky top-0 z-10 flex flex-row flex-wrap items-center p-4">
        <Typography.Title className="m-0 flex-auto" level={4}>
          Points Rules
        </Typography.Title>
        <Space className="flex flex-row">
          <Dropdown.Button
            type="primary"
            disabled={!permissions.can("LoyaltyAccrualRules", "create")}
            className={`${!permissions.can("LoyaltyAccrualRules", "create") ? "disabled" : ""}`}
            menu={{ items: [] }}
            onClick={() => onInputOpen("add")}
          >
            Add Points Rule
          </Dropdown.Button>
        </Space>
      </Row>
      <Col className="flex flex-auto flex-col overflow-hidden p-4 pb-4 pt-0">
        <PointsRulesView
          trigger={triggerView}
          onAction={(key: string, record: any) => onInputOpen(key as any, record)}
        />
      </Col>
      <PointsRuleFormDialog
        key={inputMode}
        mode={inputMode}
        open={inputOpen}
        initialValues={inputValues}
        onFinish={onInputFinish}
        onCancel={() => setInputOpen(false)}
      />
    </Col>
  );
}

export default PointsRulesPage;
